import * as React from "react";
const SvgFiRrG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-g_svg__a)">
      <path
        fill="#062147"
        d="M12.066 24C6.486 24 2 19.514 2 14v-4C2.08-.512 16.239-3.833 20.96 5.554a1 1 0 0 1-1.791.89C15.44-1.065 4.019 1.62 4 10v4c0 4.41 3.589 8 8 8 2.984-.001 5.639-1.483 7.167-3.963.38-.616.394-1.365.038-2.002A1.99 1.99 0 0 0 17.449 15h-4.448c-1.308-.006-1.307-1.994 0-2h4.448c1.473 0 2.782.77 3.502 2.059a3.93 3.93 0 0 1-.081 4.026A10.28 10.28 0 0 1 12.066 24"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-g_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrG;
